/* global Splide */

export function slickInit() {
    // Wait for DOM and make sure Splide is loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeSlider());
    } else {
        initializeSlider();
    }
}

function initializeSlider() {
    // Check if Splide is available
    if (typeof Splide === 'undefined') {
        console.error('Splide library not loaded');
        return;
    }

    const slideshow = document.querySelector('.c-slideshow');
    if (!slideshow) {
        console.log('No slideshow found on this page');
        return;
    }

    const captionSlideshow = document.querySelector('.c-caption-slideshow');
    const slideshowElements = document.querySelectorAll('.c-slideshow__single');

    // If there is more than one image
    if (slideshowElements.length) {
        try {
            // Convert slideshow to Splide structure
            wrapSlideshow(slideshow, slideshowElements);
            
            // Initialize main slideshow
            const mainSlider = new Splide('.c-slideshow', {
                type: 'slide',
                perPage: 1,
                arrows: true,
                pagination: false,
                classes: {
                    arrows: 'c-slideshow__arrows',
                    arrow: 'c-slideshow__arrow',
                    prev: 'c-slideshow__prev icon-left-open-thick',
                    next: 'c-slideshow__next icon-right-open-thick',
                }
            });

            // Initialize caption slideshow if it exists
            let captionSlider;
            if (captionSlideshow) {
                wrapCaptions(captionSlideshow);
                captionSlider = new Splide('.c-caption-slideshow', {
                    type: 'slide',
                    perPage: 1,
                    arrows: false,
                    pagination: false,
                    drag: false
                });

                // Sync the sliders
                mainSlider.sync(captionSlider);
            }

            // Track slider movements
            mainSlider.on('moved', (newIndex) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'sliderImageMove',
                    sliderImageVisible: newIndex + 1
                });
            });

            // Mount the sliders
            mainSlider.mount();
            if (captionSlider) {
                captionSlider.mount();
            }
        } catch (error) {
            console.error('Error initializing slider:', error);
        }
    }
}

function wrapSlideshow(slideshow, slides) {
    try {
        // Check if already wrapped
        if (slideshow.classList.contains('splide')) {
            return;
        }

        // Add Splide structure
        slideshow.classList.add('splide');
        
        // Create track wrapper
        const track = document.createElement('div');
        track.className = 'splide__track';
        
        // Create list
        const list = document.createElement('div');
        list.className = 'splide__list';
        
        // Move slides into list
        slides.forEach(slide => {
            slide.classList.add('splide__slide');
            list.appendChild(slide);
        });
        
        // Assemble structure
        track.appendChild(list);
        slideshow.appendChild(track);
    } catch (error) {
        console.error('Error wrapping slideshow:', error);
    }
}

function wrapCaptions(captionSlideshow) {
    try {
        // Check if already wrapped
        if (captionSlideshow.classList.contains('splide')) {
            return;
        }

        // Add Splide structure
        captionSlideshow.classList.add('splide');
        
        // Create track wrapper
        const track = document.createElement('div');
        track.className = 'splide__track';
        
        // Create list
        const list = document.createElement('div');
        list.className = 'splide__list';
        
        // Move captions into list
        Array.from(captionSlideshow.children).forEach(caption => {
            const slide = document.createElement('div');
            slide.className = 'splide__slide';
            slide.appendChild(caption);
            list.appendChild(slide);
        });
        
        // Assemble structure
        track.appendChild(list);
        captionSlideshow.appendChild(track);
    } catch (error) {
        console.error('Error wrapping captions:', error);
    }
}